import fvAxios from "../../utils/fvAxios";
import BaseUrl from "../../utils/base-uri.json";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { setInvitationURL, setInvitationVendorId, setInvitationClientId, setInvitationIsMultiClient, setInvitationPqid } from "../../utils/Token";



function UserActivation() {
  const location = useLocation();
  const search = location.search;
  const allowedPath = ["/Process/UserActivation", "/Process/InviteVendor"];

  useEffect(() => {
    if (allowedPath?.indexOf[location?.pathname] !== -1) {
      fvAxios
        .get(BaseUrl.baseUrl + location?.pathname?.substring(1) + search)
        .then((resp) => {
          window.location = resp?.data?.data?.url;
          setInvitationClientId(resp?.data?.data?.clientId);
          setInvitationIsMultiClient(resp?.data?.data?.isMultiClient);
          setInvitationPqid(resp?.data?.data?.pqId);
          setInvitationURL(resp?.data?.data?.url);
          setInvitationVendorId(resp?.data?.data?.vendorId);
        })
        .catch((err) => { });
    } else {
      window.location = "/";
    }
  }, [location.pathname, allowedPath, search]);
}

export default UserActivation;